import {Component, OnInit, OnDestroy} from '@angular/core';
import {Location} from '@angular/common';
import {delay} from "rxjs/operators";
import {Subscription} from 'rxjs';

import {SNS_NAVER_API_URL, STAR_FILTER} from '../shared/defines/protocol';
import {SEUNGJO_DISP_TYPE} from '../shared/defines/client.const';
import {OPTION_ITEM, OptionService} from '../shared/services/option/option.service';
import {SnsInfo, SnsService} from '../shared/services/sns/sns.service';
import {NaverLoginService} from "../shared/services/naver-login/naver-login.service";
import {LayoutMgrService} from '../shared/services/layout-mgr/layout-mgr.service';
import {MP_RESULT} from "../shared/components/common-popups/msg-popup.component";

// import _ from 'lodash';
// import $ from 'jquery';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit, OnDestroy {
  public StarFilter = STAR_FILTER;
  public SEUNGJO_DISP_TYPE = SEUNGJO_DISP_TYPE;

  public get optionItems(): Array<OPTION_ITEM> {
    return this.option.optionItems;
  }

  snsInfo?: SnsInfo;

  // 각각의 구독을 변수로 저장
  private login$?: Subscription;
  private snsInfo$?: Subscription;
  private userProfile$?: Subscription;

  constructor(
    private location: Location,
    private option: OptionService,
    private snsSvc: SnsService,
    private naverLoginSvc: NaverLoginService,
    private lm: LayoutMgrService,
  ) {
    // (window as any).$ = $;

    // naverLoginSvc.login 구독
    this.login$ = this.naverLoginSvc.login.pipe(
      delay(100)
    ).subscribe((naverKey: string) =>{
      this.lm.naverLoginPopup$?.next(naverKey);
      this.lm.naverLoginPopup$?.complete();
    });

    // 검증 실패 통지는 AppComponent(루트)에서 구독한다.
    // OptionsComponent가 파괴된 상태에서도 사용자에게 안내해야 하기 때문이다.

    // snsSvc.GetSnsInfo 구독
    this.snsInfo$ = this.snsSvc.GetSnsInfo().subscribe((snsInfo: SnsInfo) => {
      this.snsInfo = snsInfo;
      console.warn('OptionsComponent::constructor() snsInfo', this.snsInfo);
    });

    // naverLoginSvc.userProfile 구독
    this.userProfile$ = this.naverLoginSvc.userProfile.subscribe((naverKey: string | null) => {
      console.warn('OptionsComponent::constructor() userProfile', naverKey);

      if (naverKey === null) {
        console.error('naverKey is null');
      }
      this.lm.naverLoginPopup$?.next(naverKey);
      this.lm.naverLoginPopup$?.complete();
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    // 각 구독을 개별적으로 해제
    this.login$?.unsubscribe();
    this.snsInfo$?.unsubscribe();
    this.userProfile$?.unsubscribe();
  }

  public back(): void {
    this.location.back();
  }

  public get autoPlay(): boolean { return this.option.autoPlay; }
  public set autoPlay(value: boolean) { this.option.autoPlay = value; }
  public setAutoPlay(value: boolean): void {
    this.autoPlay = value;
  }

  public get largeMode(): boolean { return this.option.largeMode; }
  public set largeMode(value: boolean) { this.option.largeMode = value; }
  public setLargeMode(value: boolean): void {
    this.largeMode = value;
  }

  public get showSaseung(): boolean { return this.option.showSaseung; }
  public set showSaseung(value: boolean) { this.option.showSaseung = value; }
  public setShowSaseung(value: boolean): void {
    this.showSaseung = value;
  }

  public get wordLevel(): STAR_FILTER { return this.option.wordLevel; }
  public set wordLevel(value: STAR_FILTER) { this.option.wordLevel = value; }

  public get seungjoDispType(): SEUNGJO_DISP_TYPE { return this.option.seungjoDispType; }
  public set seungjoDispType(value: SEUNGJO_DISP_TYPE) { this.option.seungjoDispType = value; }

  onBookmarkSync($event: MouseEvent) {
    // console.log("### naver : ", this.snsInfo?.naver);

    if (this.snsInfo?.naver) {
      // 연동 되어있다면 연동 끊기
      this.disconnectNaverLogin();
    } else {
      // 연동 안 되어있다면 연동 하기
      this.connectNaverLogin();
    }
  }

  /*
  naverDeleteToken(token: string) {
    console.log("naver disconnect : ", token);
    fetch(`https://nid.naver.com/oauth2.0/token?grant_type=delete&client_id=${environment.naverClientId}&client_secret=${environment.naverSecretKey}&access_token=${token}&service_provider=NAVER`,
      {mode: 'no-cors'}).then(() => {}).catch((error) => console.error('Delete token :', error));
  }
  */

  private connectNaverLogin(): void {
    this.lm.OpenNaverLoginPopup().subscribe(
      (naverKey: string | null) => {
        console.warn('SnsService::connectNaverLogin() openNaverLoginPopup() naverKey =', naverKey);

        if (naverKey) { // null이 아니어야 함
          this.snsSvc.ConnectNaverId(naverKey).pipe(
            delay(200)
          ).subscribe(() => {
              this.snsInfo!.naver = true;

              this.lm.OpenMsgPopup({
                title: '책갈피 연동 성공',
                msg: '책갈피와 네이버 아이디가 연동이 되었습니다.',
                btnOk: '확인',
              }).subscribe();
            },
            (error) => {
              console.error('OptionsComponent::connectNaverLogin() ConnectNaverId failed', error);
              this.lm.OpenMsgPopupAlert(
                '네이버 아이디 연동에 실패했습니다.\n잠시 후 다시 시도해 주세요.',
                '네이버 연동 실패',
              ).subscribe({
                error: (alertError) => console.error('OptionsComponent::connectNaverLogin() OpenMsgPopupAlert failed', alertError),
              });
            }
          );
        } else {
          // null이면 취소. 정상 종료.
        }
      },
      (error) => {
        console.error(error);  // OpenNaverLoginPopup() 호출 실패
      }
    );
  }


  private disconnectNaverLogin(): void {
    const url = SNS_NAVER_API_URL;

    this.lm.OpenMsgPopup({
      title: '책갈피와 네이버 아이디 연동 해제',
      msg: '연동을 해제 하더라도 책갈피의 내용은 유지됩니다.',
      btnOk: '연동 해제',
      btnCancel: '취소',
    }).subscribe(data => {
      if (data === MP_RESULT.OK) {
        this.snsSvc.DisconnectNaverId().subscribe(
          () => {
            this.snsInfo!.naver = false;
          },
          (error) => {
            console.error(error);
          }
        );
      }
    });
  }
}
